import React from "react";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";

import MenuDialog from "./MenuDialog";
import colors from "../../assets/style/colors";

const styles = {
  menuItem: {
    height: "54px",
    margin: "20px 0px",
    padding: "5px 0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  menuItemActive: {
    backgroundColor: colors.lightGreenBg,
  },
  tooltip: {
    fontSize: "1em",
  },
};

const MenuElement = (props) => {
  const { history, item, classes, active } = props;
  const [hover, setHover] = React.useState(false);

  const handleClick = (url) => {
    history.push(url);
  };

  const renderMenuItem = () => (
    <Tooltip
      title={I18n.get(`sidebar_${item.name}`)}
      placement="right"
      arrow
      classes={{ tooltip: classes.tooltip }}
    >
      <MenuItem
        onClick={() =>
          item.dialog ? {} : handleClick(item.url || `/${item.name}`)
        }
        className={clsx(classes.menuItem, {
          [classes.menuItemActive]: active,
        })}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <img
          src={active || hover ? item.icons.green : item.icons.black}
          alt={`${item.name}_logo`}
        />
      </MenuItem>
    </Tooltip>
  );

  if (item.dialog) {
    return <MenuDialog item={item}>{renderMenuItem()}</MenuDialog>;
  }

  return renderMenuItem();
};

export default withRouter(withStyles(styles)(MenuElement));
